/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useContext, useEffect, useRef, useState, useCallback } from 'react'
import CardHeader from '../../../components/CardHeader'
import UpdateButton from '../../../components/UpdateButton'
import Toast from '../../../components/Toast'
import Input from '../../../components/InputBox'
import CustomOverLay from '../../../components/CustomOverlay' 
import CustomeDatePicker from '../../../components/DatePicker'
import moment from 'moment'
import { dataService } from '../../../services/data.services'
import { GetBranchId } from '../../../CommonMethods/GetBranchId'
import { useNavigate, useParams } from 'react-router-dom'
import GlobalContext from '../../../components/Context/GloablContext'
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick'
import DropDownComponent from '../../StudentMaster/Directory/Components/AddStudentComponents/DropDownComponent'
import WarningMessage from '../../../components/WarningMessage'
import { useSelector } from 'react-redux'
import Debounce from '../../../CommonMethods/Debounce'
import {formatAdjustedDate} from '../../../CommonMethods/formatDate'
import ImageSizeTooltip from '../../../components/ProfileImageUpload/imageSizeTooltip'
import { ShimmerTitle } from 'react-shimmer-effects'

export default function AddGRNEntry({type}) {
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const {setToastmessage, reloadFY, setReloadFY} = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const nonEmptyField = [ "po_number", "grn_date", "vendor_invoice"]
    const [allDataList, setAllDataList] = useState([])
    const moment = require('moment');
    const currentDate = moment();
    let formattedDate = '';
    const fy = JSON.parse(localStorage.getItem('FY_details'));
    const fy_start_date = new Date(fy.start_date);
    const fy_end_date = new Date(fy.end_date);
    if ((currentDate >= fy_start_date && currentDate <= fy_end_date)) {
        formattedDate = currentDate.format('MMM DD,YYYY');
    }
    const initialState = {
        po_number : "",
        po_id: "",
        grn_date: formattedDate,
        financial_year: `${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`,
        vendor_name : "",
        vendor_invoice : ""
    }
    const newFields = {item_name: '', item_code: '', uom :"" , ledger: "",po_quantity : "", rcvd_quantity : "", bal_quantity: "",cost_per_item: "",total_cost : ""}
    const [loadingPage, setLoadingPage] = useState(true)
    const [newStateFields, setNewStateFields] = useState([newFields]);
    const [state, setState] = useState(initialState) 
    const [warningMessage, setWarningMessage] = useState('')
    let {id} = useParams();
    const [ledgerList, setLedgerList] = useState([])
    const [selectedSearch,setSelectedSearch]=useState('')
    const inputRef=useRef()
    const [dateError, setdateError] = useState("")
    const [poNumberDropdownData,setpoNumberDropdownData]=useState([])
    const [POSearchStarted,setPOSearchStarted]=useState(false)
    const [showPODropdownData,setShowPODropdownData]=useState(false)
    const [isPoClear, setIsPoClear] = useState(false)
    const [submitSelected, setsubmitSelected] = useState(false);
    const [qtyError, setqtyError] = useState(false);
    const [costError, setcostError] = useState(false);
    const [qty2Error, setqty2Error] = useState(false);
    const [isUnique, setIsUnique] =  useState(true)
    const {userType} = useSelector((state)=>state.auth);
    const [handleFieldError, setHandleFieldError] = useState("")
    const navigate = useNavigate()
    const [showDropdown, setshowDropdown] = useState({
        blood_group: false,
        gender: false,
        economic_status: false,
        religion: false,
        caste_category: false,
        academic_year: false,
        class: false,
        section: false,
    });

    /**
     * The function `handleValidations` checks if certain fields in the `state` object are empty or
     * have whitespace and returns a boolean indicating if any of the fields are invalid.
     * @returns a boolean value. It returns true if there are any empty fields in the state or
     * newStateFields, and false otherwise.
     */
    const handleValidations = () => {
        let count = 0
        nonEmptyField.map((item) => {
            if(state[item] === "") {
                count = count + 1
            }
        })
        const fields = ["item_name", "rcvd_quantity", "cost_per_item", "item_code", "ledger"];
        newStateFields.forEach((item) => {
            fields.forEach((field) => {
                if (typeof item[field] === 'string' && item[field].trim() === "") {
                    count++;
                }
            });
        });
        return count !== 0;
        
    }

    const clearIfValueIsZero = (index, name) => (e) => {
        if (Number(e.target.value) === 0) {
            handleFieldChange(index, name, '');
        }
    };

    const setZeroIfEmpty = (index, name) => (e) => {
        let value = e.target.value;
        if (value.trim() === '') {
            value = '0.00';
        } else {
            value = parseFloat(value).toFixed(2);
        }
        handleFieldChange(index, name, value);
    };


    const handleQuantity = () => {
        let count = 0
        let quantity = 0;
        let cost = 0
        newStateFields.forEach((item) => {
            if (item["rcvd_quantity"] === "" || Number(item["rcvd_quantity"]) === 0 ) {
                count++;
                quantity++;
            }
            if (item["cost_per_item"] === "" || parseFloat(Number(item["cost_per_item"])).toFixed(2) === "0.00") {
                count++;
                cost++;
            }
        });
        if(quantity === 0 && cost !== 0) {
            setToastErrorMessage("Cost / Item cannot be zero")
        } else if(quantity !== 0 && cost === 0) {
            setToastErrorMessage("Rcvd Qty cannot be zero")
        } else if(quantity !== 0 && cost !== 0) {
            setToastErrorMessage("Rcvd Qty and Cost / Item cannot be zero ")
        }
        return count !== 0;
    }

    /**
     * The `handleSubmit` function is used to handle the submission of a form, perform validations,
     * extract data from the form fields, make an API call to create a new entry, and display success
     * or error messages.
     * @returns The function `handleSubmit` does not have a return statement.
     */
    const handleSubmit = async() => {
        setToastErrorMessage("")
        if(!(userType==='institution-user' || userType==='institution-admin') && type === "Add") {
            const branch_id = await GetBranchId()
            const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing&sort=status%2Basc`, true);
            if(res.data.data.ongoing !== JSON.parse(localStorage.getItem('FY_details')).name) {
                setToastErrorMessage(`You are not authorized to add GRN for the ${JSON.parse(localStorage.getItem('FY_details')).name}. Please refresh the page.`)
                return
            }
        }
        if(openConfirmation) {
            setActivateButtonLoading(true)
        } else {
            setLoading(true)
        }
        if(handleValidations()){
            setsubmitSelected(true)
            setToastErrorMessage("Please fill in all the mandatory fields")
            setLoading(false)
            setOpenConfirmation(false)
            setActivateButtonLoading(false)
            return
        } else if(handleQuantity()) {
            setqty2Error(true)
            setsubmitSelected(true)
            setLoading(false)
            setOpenConfirmation(false)
            setActivateButtonLoading(false)
            return 
        } else {
            // Validate if received quantity exceeds PO quantity
            const exceededQuantityItems = newStateFields.filter(item => parseFloat(item.rcvd_quantity) > parseFloat(item.po_quantity));
            
            if (exceededQuantityItems.length > 0) {
                setsubmitSelected(true)
                setqtyError(true)
                setToastErrorMessage(`Rcvd Qty cannot be more than PO Qty. Adjust accordingly.`);
                setLoading(false);
                setOpenConfirmation(false);
                setActivateButtonLoading(false);
                return;
            }

            const exceededCostItems = newStateFields.filter(item => parseFloat(item.cost_per_item) > parseFloat(item.cost_price));
            
            if (exceededCostItems.length > 0) {
                setsubmitSelected(true)
                setcostError(true)
                setToastErrorMessage(`Cost/Item cannot be more than the amount specified in the '${state.po_number}'`);
                setLoading(false);
                setOpenConfirmation(false);
                setActivateButtonLoading(false);
                return;
            }
            try {
                const keysToExtract = [
                    "item_name",
                    "item_code",
                    "uom",
                    "ledger",
                    "po_quantity",
                    "rcvd_quantity",
                    "bal_quantity",
                    "cost_per_item",
                    "total_cost",
                    "ledger_id"
                ];
                  
                const extractedArray = newStateFields.map(item => {
                    const extractedItem = {};
                    keysToExtract.forEach(key => {
                        extractedItem[key] = item[key];
                    });
                    return extractedItem;
                });  
                const FY_details = JSON.parse(localStorage.getItem('FY_details'));
                let body = {
                    items: extractedArray,
                    grn_date : moment(state?.grn_date).format("YYYY-MM-DD"),
                    branch_id : await GetBranchId(),
                    po_number : state.po_number,
                    po_id: state.po_id,
                    vendor_name : state.vendor_name,
                    vendor_invoice : state.vendor_invoice.trim(),
                    financial_year: FY_details.name,
                    is_unique: isUnique,
                    vendor_id : state.vendor_id,
                    grn_total :  newStateFields.reduce((acc, item) => acc + (parseFloat(item.total_cost) || 0), 0).toFixed(2)
                }
                let response = null
                response = await dataService.PostAPI(body, 'grn-entry');
                setIsUnique(true)
                setOpenConfirmation(false)
                setToastmessage(response?.data.data?.message);
                setLoadingPage(true)
                setLoading(false)
                navigate('/inventory-master/grn-entry')
                setTimeout(() => {
                    setNewStateFields([newFields]); 
                    setState(initialState)
                    setSelectedSearch("")
                    setLoadingPage(false)
                }, 500);
            } catch (error) {
                setOpenConfirmation(false)
                setActivateButtonLoading(false)
                setLoading(false);
                if(error?.response?.data?.message === "Vendor Invoice already exists. Try another") {
                    setIsUnique(false);
                } else {
                    setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                    // navigate('/inventory-master/grn-entry/add-grn-entry')
                    if(error?.response?.status === 500){
                        handleClear()
                    }
                }
            }
        }
    }

    /**
     * The `handleInput` function is used to handle input changes in a form, specifically for the
     * "description" field. It counts the number of words in the description and updates the state
     * accordingly. If the word count exceeds 100, it sets an error message. For other input fields, it
     * simply updates the state with the new value.
     */
    const handleInput = (e) => {
        setqtyError(false)
        setqty2Error(false)
        setcostError(false)
        let {id,value}=e.target
        if(id === "description") {
            const words = value.trim().split(/\s+/);
            const currentWordCount = words?.length;
            if (currentWordCount <= 100) {
                setState((prv)=>({
                    ...prv,
                    [id]:value
                }))
            } else {
                setToastErrorMessage("Description cannot exceed 100 words")
            }
        } else {
            setState((prv)=>({
                ...prv,
                [id]:value
            }))
        }
    }

    /**
     * The function `handleSelectedDate` checks if a selected date is within a specified range and
     * updates the state accordingly, while also handling errors and displaying error messages.
     */
    const handleSelectedDate = (id, date, dateString) => {
        setHandleFieldError("")
        const FY_details = JSON.parse(localStorage.getItem('FY_details'));
        // Parse the selected date and start date, and ignore the time by using .startOf('day')
        const selectedDate = moment.utc(dateString).startOf('day'); // Parse as UTC and ignore time
        const startDate = moment.utc(state.po_date).startOf('day'); // Parse as UTC and ignore time

        // Parse the end date string and ignore time
        const endDate = moment.utc(FY_details.end_date).startOf('day'); // Parse as UTC and ignore time
        
        if (selectedDate.isAfter(startDate) && selectedDate.isSameOrBefore(endDate)) {
            // The selected date is after to the start date, so update the state
            setState((prev) => ({
                ...prev,
                [id]: dateString,
            }));
        } else if (selectedDate.isSame(startDate)) { //allow if GRN date is same as PO date
            // The selected date is the same as the start date (valid, no error)
            setState((prev) => ({
                ...prev,
                [id]: dateString,
            }));
        } else {
            // The selected date is before the start date, so throw an error
            setHandleFieldError(id)
            setState((prev) => ({
                ...prev,
                [id]: "",
            }));
            setToastErrorMessage(`GRN Date (${new Date(dateString).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })}) must be within ${FY_details.name} and on/after PO Date: ${new Date(state.po_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })}`);
            // You can also set an error message in the state if needed.
        }
    };
    
    /**
     * The function `handleDropDownValue` updates the state fields based on the selected dropdown value
     * and handles error messages if necessary.
     * @returns The function does not explicitly return anything.
     */
    const handleDropDownValue = (key, value, index) => {
        const exist_value = value;
        const updatedClassFields = [...newStateFields];
        if (key === "ledger") {
            updatedClassFields[index]["ledger"] = value.parent_group_name_composite_key;
            updatedClassFields[index]["ledger_id"] = value._id;

        } else {
            const itemExists = updatedClassFields.some((field, i) => i !== index && field.item_name === exist_value.item_name);
    
            if (itemExists) {
                // Show toast message without changing the list
                setToastErrorMessage(`Item name "${exist_value.item_name}" already exists. Try changing the quantity for the existing one`);
                // updatedClassFields[index]["item_name"] = '';

                return;
            }
            updatedClassFields[index]["item_name"] = exist_value.item_name;
            updatedClassFields[index]["item_code"] = exist_value.item_code;
            updatedClassFields[index]["uom"] = exist_value.uom;
            updatedClassFields[index]["quantity"] = exist_value.quantity;
            updatedClassFields[index]["po_quantity"] = exist_value.po_quantity;
            updatedClassFields[index]["rcvd_quantity"] = exist_value.po_quantity;
            updatedClassFields[index]["bal_quantity"] = exist_value.bal_quantity;
            updatedClassFields[index]["cost_per_item"] = exist_value.cost_price;
            updatedClassFields[index]["total_cost"] = exist_value.cost_price * exist_value.rcvd_quantity;
            updatedClassFields[index]["rcvd_quantity"] = exist_value.rcvd_quantity;
        }
        setNewStateFields([...updatedClassFields]);
        handleDropdown(key);
    };
    

    /**
     * The function `handleDropdown` toggles the visibility of a dropdown menu and resets an error
     * message and submit status.
     */
    const handleDropdown = (key) => {
        setToastErrorMessage('')
        setsubmitSelected(false);
        setqtyError(false)
        setqty2Error(false)
        setcostError(false)
        setshowDropdown((prv) => ({
            ...prv,
            [key]: !showDropdown[key],
        }));
    };

    /**
     * The function `handleRemoveClassField` removes a class field from the state array and updates the
     * state with the updated array.
     */
    const handleRemoveClassField = (indexToRemove) => {
        setsubmitSelected(false)
        setqtyError(false)
        setcostError(false)
        setqty2Error(false)
        setToastErrorMessage('')
        const updatedClassFields = newStateFields.filter((_, index) => index !== indexToRemove);
        setNewStateFields([...updatedClassFields]);
    };

    /**
     * The function `handleAddClassField` adds a new field to an array of class fields and displays a
     * warning message if the array length reaches 19.
     */
    const handleAddClassField = () => {
        setsubmitSelected(false)
        setqtyError(false)
        setqty2Error(false)
        setcostError(false)
        setToastErrorMessage('')
        const updatedClassFields = [
            ...newStateFields,
            newFields,
        ];
        setNewStateFields([...updatedClassFields]);

        if (newStateFields?.length === 19)  {
            setToastErrorMessage('')
            setWarningMessage("Items")
        }
    };

    /**
     * The `handleFieldChange` function is used to handle changes in input fields, validate the input,
     * and update the state accordingly.
     * @returns The function does not explicitly return anything.
     */
    const handleFieldChange = (index, name, value) => {
        setToastErrorMessage("")
        setsubmitSelected(false)
        setqty2Error(false)
        setqtyError(false)
        setcostError(false)
        // Remove any non-numeric and non-dot characters
        const inputValue = name === "rcvd_quantity" ? value.replace(/[^\d]/g, '') :  value.replace(/[^\d.]/g, '');
        const updatedClassFields = [...newStateFields];
        if(name === "rcvd_quantity") {
            if(Number(value) > Number(newStateFields[index]["po_quantity"])) {
                setToastErrorMessage(`${newStateFields[index]['item_name']} [${newStateFields[index]['item_code']}]: Rcvd Qty cannot be more than PO Qty of ${newStateFields[index]["po_quantity"]}. Adjust accordingly.`);
                updatedClassFields[index][name] = inputValue;
            } else {
                updatedClassFields[index]["bal_quantity"] = newStateFields[index]["po_quantity"] - inputValue
                updatedClassFields[index]["cost_per_item"] !== "" ? updatedClassFields[index]["total_cost"] = inputValue * newStateFields[index]["cost_per_item"] : updatedClassFields[index]["total_cost"] = ''
                updatedClassFields[index][name] = inputValue;
            }
         
        } else {
            if(parseFloat(value) > parseFloat(newStateFields[index]["cost_price"])) {
                setToastErrorMessage(`${newStateFields[index]['item_name']} [${newStateFields[index]['item_code']}]: Cost/item cannot be more than ${parseFloat(newStateFields[index]["cost_price"]).toFixed(2)} as specified in the '${state.po_number}'`);
                if (inputValue?.length <= 13 ) {
                    // Allow only up to 2 decimal places
                    const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
                    if (regex.test(inputValue)) {
                        updatedClassFields[index][name] = inputValue;
                        updatedClassFields[index]["rcvd_quantity"] !== "" ? updatedClassFields[index]["total_cost"] = inputValue * newStateFields[index]["rcvd_quantity"] : updatedClassFields[index]["total_cost"] = ''
                    }
                }
            } else {
                if (inputValue?.length <= 13 ) {
                    // Allow only up to 2 decimal places
                    const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
                    if (regex.test(inputValue)) {
                        updatedClassFields[index][name] = inputValue;
                        updatedClassFields[index]["rcvd_quantity"] !== "" ? updatedClassFields[index]["total_cost"] = inputValue * newStateFields[index]["rcvd_quantity"] : updatedClassFields[index]["total_cost"] = ''
                    }
                }
            } 
            // Limit to a maximum length of 5 characters (including decimal and decimals)
            
        }
        setNewStateFields([...updatedClassFields]); 
    }

    /**
     * The function `getViewData` retrieves data from an API endpoint and updates the state with the
     * received data.
     */
    const getViewData = async() => {
        const res= await dataService.GetAPI(`purchase-order/${id}&role=grn-entry`);
        setNewStateFields([...res?.data?.data?.items])
        setState({
            po_date: res?.data?.data.po_date,
            po_number: res?.data?.data?.po_number,
            po_id: res?.data?.data?._id,
            financial_year: res?.data.data?.financial_year,
            description : res?.data?.data?.description,
            vendor_name : res?.data?.data?.vendor_name,
            delivery_date : res?.data?.data?.delivery_date
        })
        setLoadingPage(false)
    }

    /**
     * The function `getLedger` retrieves a list of ledger names for active expenses and purchases from
     * a specific branch.
     */
    const getLedger = async() => {
        const branch_id = await GetBranchId()
        const res= await dataService.GetAPI(`groups-and-ledgers?branch_id=${branch_id}&type=ledger&search=Expenses > Purchases&status=active&filter=true&list_ledger=true&role=grn-entry`);
        setLedgerList(res?.data?.data?.data);
    }

    /* The above code is a React useEffect hook that is triggered whenever the `reloadFY` variable
    changes. */
    useEffect(() => {
        const fetchData = async () => {
            // Assuming getFeeHeadList and getAcademicyears are async functions
            try{
                setLoadingPage(true)
                await getLedger();
    
                setTimeout(() => {
                    const FY_details = JSON.parse(localStorage.getItem('FY_details'));
                    const financial_year = `${FY_details.name} (${FY_details.status.charAt(0).toUpperCase() + FY_details.status.slice(1)})`;
        
                    setState(prevState => ({
                        ...prevState,
                        financial_year
                    }));
        
                    setLoadingPage(false); // Set loading to false after timeout
                }, 1000); // 2000 ms = 2 seconds
        
            } catch (error) {
                console.log(error);
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
                setLoadingPage(false); // Set loading to false in case of error
            }
        };
        fetchData();
        if(reloadFY) {
            setLoadingPage(true)
            if(type === "Add") {
                setState(initialState)
                setNewStateFields([newFields])
            } else {
                getViewData()
            }
            setReloadFY(false)
            setTimeout(() => {
                setLoadingPage(false)
            }, 1000);
        } else {
            if(type === "Edit") {
                getViewData()
            }
        }
    },[reloadFY])

    const handlePONumberSearch = useCallback(
        Debounce((key, value) => handlePONumberSearchDebounce(key,value)),
        []
    );

    /**
     * The function `handlePONumberSearch` is an asynchronous function that takes a search parameter
     * and performs a search for purchase orders based on that parameter.
     */
    const handlePONumberSearchDebounce = async(search) => {
        setPOSearchStarted(true)
        let searchValue = encodeURIComponent(search).replace(/[#&]/g, '\\$&').trim()
        if (searchValue.trim() !== "") {
            setTimeout(async() => {
                const branch_id = await GetBranchId()
                const response = await dataService.GetAPI(`purchase-order?branch_id=${branch_id}&search=${searchValue}&filter=true&financial_year=${JSON.parse(localStorage.getItem('FY_details')).name}&statuses=true&role=grn-entry`, true);
                setpoNumberDropdownData(response?.data?.data?.data)
                setShowPODropdownData(true)
            }, 700);
        } else{
            setpoNumberDropdownData([])
            setPOSearchStarted(false)
            setShowPODropdownData(false)
        }
    }

    

    /* The above code is using the `useOnClickOutside` hook in a React component. This hook is used to
    detect when a click event occurs outside of a specified element, in this case, the `inputRef`
    element. */
    const [outSideClickTriggered, setOutSideClickTriggered] = useState(false)
    useOnClickOutside(inputRef,()=>{
        if(state.po_number !== "") {
            setSelectedSearch(state.po_number+' ('+formatAdjustedDate(state.po_date)+')')
        }
        setpoNumberDropdownData([])
        setPOSearchStarted(false)
        setShowPODropdownData(false)
        setOutSideClickTriggered((prev) => !prev)
    })

    /**
     * The function `handleSelectPoNumber` updates various state variables and performs some data
     * manipulation based on the selected PO number.
     */
    const handleSelectPoNumber = (items) => {
        if (allDataList?.length === 0) {
            setAllDataList(items)
        }
        setToastErrorMessage("")
        setsubmitSelected(false)
        setqtyError(false)
        setqty2Error(false)
        setcostError(false)
        setState({
            po_number : items.po_number,
            po_id: items?._id,
            grn_date: formattedDate,
            vendor_name : items.vendor_name,
            vendor_invoice : "",
            po_date: items.po_date,
            vendor_id : items.vendor_id
        })
        for (var i = 0; i < items.items?.length; i++) {
            items.items[i].po_quantity = items.items[i].quantity;
            items.items[i].rcvd_quantity = items.items[i].quantity;
            items.items[i].ledger = "";
            items.items[i].cost_per_item = parseFloat(items.items[i].cost_price===''?0:items.items[i].cost_price).toFixed(2);
            items.items[i].total_cost = items?.items[i]?.cost_price * items?.items[i]?.quantity;
            items.items[i].bal_quantity = 0
            delete items.items[i].quantity  
        }     
        const poNumberWithDate = items.po_number+' ('+formatAdjustedDate(items.po_date)+')'
        setNewStateFields([...items?.items])
        setSelectedSearch(poNumberWithDate)
        setpoNumberDropdownData([])

    }

    /**
     * The function `handleClear` resets various state variables to their initial values.
     */
    const handleClear = () => {
        setNewStateFields([newFields]); 
        setState(initialState); 
        setSelectedSearch(""); 
        setsubmitSelected(false)
        setqtyError(false)
        setqty2Error(false)
        setcostError(false)
        setIsPoClear(false)
    }

    useEffect(()=>{
        //handlePONumberSearch()
    },[])

    const disabledFutureDate = (current) => {
        // Disable dates that are after the current date
        return current && current > moment().endOf('day');
    };
    
    const [imageSizeInfoHover, setImageSizeInfoHover] = useState(false)
    const handleImageToggle = () => {
        // Use the functional form of setState
        setImageSizeInfoHover((prevIsToggled) => !prevIsToggled);
    };

    return (
        <CardHeader noPadding>
            <div class="mainDataCntnrTop shadow-s13" style={{position: "sticky", position: "-webkit-sticky"}}>
                <h5 class="pageHeader addclass">GRN Entry</h5>
                <div class="flex items-center">
                    <UpdateButton
                        ButtonName={"Cancel"}
                        loading={false}
                        handleOnCLick={() => {navigate('/inventory-master/grn-entry')}}
                        classKey="cancl-btn"
                    />
                    <UpdateButton
                        loading={loading}
                        ButtonName={type !== "Add" ? "Update" : "Add"}
                        handleOnCLick={() => {handleSubmit()}}
                        classKey={"actn-btn onboardInstitution"}
                    />
                </div>
                {toastErrorMessage!=='' &&<Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
                {warningMessage !== "" && <WarningMessage 
                    warningMessage={warningMessage}
                    setWarningMessage={setWarningMessage}
                />}
            </div>
            {loadingPage && <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}
            {!loadingPage &&  <div className='mainDataCntnrPageDiv scroll-bar'>
                <div className='2xl:w-[60%] w-[80%] mx-auto'>
                    <div className='border border-[#D0D5DD] p-3 rounded'>
                        <div className='flex -mx-10'>
                            <div className='w-[50%] px-10'>
                                <div className='flex relative'>
                                    <div className=' flex items-center mb-4 w-full relative'>
                                        <label for="date_of_birth" class="text-f7 font-normal text-[#031624] min-w-[115px] inline-flex">PO #</label>
                                        <div class="relative w-full" ref={inputRef}>
                                            <input 
                                                type="text" 
                                                id='po_number'
                                                className={`${submitSelected && state.po_number === "" ? "redBorder" : ""} slct-inpt-fld error_border`}
                                                placeholder="Search and Select PO #" 
                                                disabled={state.po_number !== ""}
                                                onChange={event=>{setSelectedSearch(event.target.value); handlePONumberSearch(event.target.value)}}
                                                value={selectedSearch}
                                                title={selectedSearch}
                                                autocomplete="off" />
                                            {state.po_number === "" && <button class="absolute top-[50%] -translate-y-[50%] right-2">
                                                <img loading="lazy" decoding="async" src="/images/search.svg" alt="img"/>
                                            </button>}
                                            {POSearchStarted && (
                                                <ul className="slct_drp_dwn min-w-full select_student" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                                                    <li className="max-h-[150px] overflow-auto scroll-bar">
                                                        {showPODropdownData ? (
                                                            poNumberDropdownData?.length === 0 ? (
                                                                <ul>
                                                                    <li>
                                                                        <a
                                                                            onClick={() => { }}
                                                                            className="selected_Class"
                                                                            href="#"
                                                                            data-te-dropdown-item-ref
                                                                        >
                                                                            - No PO found -
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            ) : (
                                                                <>{poNumberDropdownData?.map((student)=>(
                                                                    <ul key={type === "staff" ? student.employee_number : student.student_id}>
                                                                        <li>
                                                                            <p 
                                                                                onClick={() => {handleSelectPoNumber(student); setPOSearchStarted(false); setShowPODropdownData(false)}}
                                                                                title={student?.po_number+' ('+formatAdjustedDate(student?.po_date)+')'}
                                                                                class="slct_drp_dwn_optn selected_Class" href="#" data-te-dropdown-item-ref>
                                                                                {student?.po_number+' ('+formatAdjustedDate(student?.po_date)+')'}
                                                                            </p>
                                                                        </li>
                                    
                                                                    </ul>
                                                                ))
                                                                }</>
                                                            )
                                                        ) : (
                                                            <li className="max-h-[150px] overflow-auto scroll-bar" style={{ 'padding': '0.3rem 0.5rem' }}>
                                                                <p className="text-2xl font-bold text-[#031624] mb-4 mt-4"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                                                            </li>
                                                        )}
                                                    </li>
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                    {state.po_number !== "" && 
                                        <div className='absolute top-2 right-[-23px]'>
                                            <img 
                                                src="/images/clear.svg" 
                                                alt="clear-icon" 
                                                className='cursor-pointer  h-[21px] w-[17px]'
                                                onClick={() => {setIsPoClear(true)}}
                                                title='Clear PO #'
                                            />
                                        </div>
                                    }
                                </div>
                                <div className='flex'>
                                    <div className='relative flex items-center mb-4 w-full'>
                                        <label for="date_of_birth" class={`text-f7 font-normal text-[#031624] min-w-[115px] inline-flex`}>GRN Date</label>
                                        <div class="relative w-full">
                                            <CustomeDatePicker 
                                                setToastErrorMessage={setToastErrorMessage}
                                                setsubmitSelected={setsubmitSelected}
                                                id='grn_date'
                                                showErrorBorder={((submitSelected && state.grn_date === "") || handleFieldError === "grn_date")}
                                                format="MMM DD, YYYY"
                                                state={state}
                                                placeholder="Select GRN Date"
                                                imageClass={true}
                                                setdateError={setdateError}
                                                handleSelect={handleSelectedDate}
                                                disabledFutureDate={disabledFutureDate}
                                                disabledDate={state.po_number === ""}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='relative flex items-center w-full'>
                                        <label for="date_of_birth" class={`text-f7 font-normal text-[#031624] min-w-[115px] inline-flex`}>Financial Year</label>
                                        <div class="relative w-full">
                                            <Input 
                                                type="text"
                                                state={state}
                                                id="financial_year"
                                                maxLength={30}
                                                handleInput={handleInput}
                                                placeholder={"Financial Year"}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                disable={true}
                                                isMandatoryField = {true}   
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='w-[50%] px-10 pl-6'>
                                <div className='flex'>
                                    <div className='relative flex items-center mb-4 w-full'>
                                        <label for="vendor_name" class="text-f7 font-normal text-[#031624] min-w-[135px] inline-flex">Vendor Name</label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="vendor_name"
                                            maxLength={30}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Vendor Name"}
                                            disable={true}
                                            placeholder={"Vendor Name"}
                                            isMandatoryField = {true}
                                            showErrorBorder = {submitSelected && state.po_number === ""}
                                        />
                                    </div>
                                </div>
                                <div className='flex'>
                                    <div className='flex items-center mb-4 w-full'>
                                        <label
                                            htmlFor='uom'
                                            className='text-f7 font-normal text-[#031624] min-w-[135px] inline-flex'
                                        >
                                            Vendor Invoice #
                                        </label>
                                        <Input 
                                            type="text"
                                            state={state}
                                            id="vendor_invoice"
                                            maxLength={30}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text={"Enter Invoice #"}
                                            placeholder={"Enter Invoice #"}
                                            isMandatoryField = {true}
                                            showErrorBorder = {submitSelected && state.vendor_invoice === ""}
                                        />
                                    </div>
                                    <div class="relative self-end ml-2" style={{ 'top': '-23px' }}>
                                        <ImageSizeTooltip
                                            handleImageToggle={handleImageToggle}
                                            imageSizeInfoHover={imageSizeInfoHover}
                                            imgtransform={'scale(1.5)'}
                                            tooltipFor={'GRN_INV_#'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
                <div className='mb-4 2xl:w-[90%] mx-auto border border-[#E6E8EA]' style={{'margin-top':'45px'}}>
                    <div className='flex items-center' >
                        <div className={`flex items-center p-2 pb-[10px] border-b border-[#E6E8EA] ${newStateFields?.length === 1 ? "w-[100%]" : "w-[100%]"} `} style={{'background-color':'#f1f1f1'}}>
                            <div className='px-1 w-[18%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624] mr-4'>Item Name</p>
                            </div>
                            <div className='px-2 w-[13%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624]'>Item Code</p>
                            </div>
                            <div className='px-2 w-[9%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624]'>UoM</p>
                            </div>
                            <div className='px-2 w-[14%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624]'>Ledger</p>
                            </div>                            
                            <div className='px-2 w-[9%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624]'>PO Qty</p>
                            </div>
                            <div className='px-2 w-[9%]'>
                                <p className='w-full text-f7 font-semibold text-[#031624]'>Rcvd Qty</p>
                            </div>
                            <div className='px-2 w-[9%] pl-1'>
                                <p className='w-full text-f7 font-semibold text-[#031624]'>Bal Qty</p>
                            </div>
                            <div className='pl-2 w-[13%] pr-1'>
                                <p className='w-full text-f7 font-semibold text-[#031624] text-right'>Cost / Item</p>
                            </div>
                            <div className='pl-2 w-[13%] pr-1'>
                                <p className='w-full text-f7 font-semibold text-[#031624] text-right'>Total Cost</p>
                            </div>

                            <div className={`${newStateFields?.length === 1 ? "w-[7%]" : "w-[7%]"} `}>
                            </div>
                        </div>
                    </div>
                    {newStateFields.map((field, index) => (
                        <div className='flex items-center' key={index+"po"}>
                            <div className={`flex items-center mt-[10px] pb-[10px] border-b border-[#E6E8EA] ${newStateFields?.length === 1 ? "w-[100%]" : "w-[100%]"} `}>
                                <div className='w-[18%] px-2'>
                                    <div className='w-full'>
                                        <DropDownComponent
                                            divClassName={'relative w-full'}  
                                            showErrorBorder={submitSelected && state.vendor_name === ""}
                                            options={allDataList?.items}
                                            dropdownkey={"item_code"}
                                            studentDetails={state}
                                            submitSelected={submitSelected}
                                            handleDropDownValue={handleDropDownValue}
                                            showDropdown={showDropdown}
                                            handleDropdown={handleDropdown}
                                            placeholder={"Select Item Name"}
                                            selectedvalue={field.item_name}
                                            stateStatus={allDataList?.length === 0 || state.po_number === "" ? true : false}
                                            index={index}
                                            outSideClickTriggered={outSideClickTriggered}
                                            obj
                                        />
                                    </div> 
                                </div>
                                <div className='w-[13%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            disabled
                                            type="text"
                                            autoComplete='off'
                                            id={`item_code${index}`}
                                            maxLength={30}
                                            className={`${submitSelected && field.item_code === "" ? "redBorder" : ""} w-full inpt-fld error_border`}
                                            placeholder={``}
                                            value={field.item_code}
                                            title={field.item_code}
                                        />
                                    </div> 
                                </div>
                                
                                <div className='w-[9%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            disabled
                                            type="text"
                                            autoComplete='off'
                                            id={`uom${index}`}
                                            maxLength={30}
                                            className={`${submitSelected && field.uom === "" ? "redBorder" : ""} w-full inpt-fld error_border`}
                                            placeholder={``}
                                            value={field.uom}
                                            title={field.uom}
                                        />  
                                    </div>   
                                </div>
                                <div className='w-[14%] px-2'>
                                    <div className='w-full'>
                                        <DropDownComponent
                                            divClassName={'relative w-full'}  
                                            showErrorBorder={submitSelected && (field.ledger === "" || field.ledger === undefined)}
                                            options={ledgerList}
                                            dropdownkey={"ledger"}
                                            studentDetails={state}
                                            submitSelected={submitSelected}
                                            handleDropDownValue={handleDropDownValue}
                                            showDropdown={showDropdown}
                                            handleDropdown={handleDropdown}
                                            placeholder={"Select Ledger"}
                                            title={field.ledger}
                                            selectedvalue={field.ledger!=undefined?field.ledger.substring(field.ledger.lastIndexOf('>') + 1).trim():field.ledger}
                                            index={index}
                                            listWidth={`210px`}
                                            obj={"parent_group_name_composite_key"}
                                            outSideClickTriggered={outSideClickTriggered}
                                        />     
                                    </div>   
                                </div>
                                <div className='w-[9%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            type="text"
                                            disabled
                                            autoComplete='off'
                                            id={`po_quantity${index}`}
                                            maxLength={30}
                                            className={`${submitSelected && field.po_quantity === "" ? "redBorder" : ""} w-full inpt-fld error_border`}
                                            placeholder={`1`}
                                            value={field.po_quantity}
                                        />  
                                    </div>   
                                </div>
                                <div className='w-[9%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            type="text"
                                            autoComplete='off'
                                            id={`rcvd_quantity${index}`}
                                            maxLength={13}
                                            className={`${submitSelected && (field.rcvd_quantity === "" || field.rcvd_quantity === undefined || ( qty2Error && Number(field.rcvd_quantity)) === 0 || (qtyError &&Number(field.rcvd_quantity) > Number(field.po_quantity))) ? "redBorder" : ""} w-full inpt-fld error_border`}
                                            placeholder={`1`}
                                            value={field.rcvd_quantity}
                                            onChange={(e) => { handleFieldChange(index, 'rcvd_quantity', e.target.value)}}
                                            disabled={field.item_name === ''}
                                        />  
                                    </div>   
                                </div>
                                <div className='w-[9%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            type="text"
                                            disabled
                                            autoComplete='off'
                                            id={`bal_quantity${index}`}
                                            maxLength={30}
                                            className={` ${submitSelected && (field.bal_quantity === "" || field.bal_quantity === undefined) ? "redBorder" : ""} w-full inpt-fld error_border`}
                                            placeholder={`1`}
                                            value={field.bal_quantity}
                                        />  
                                    </div>   
                                </div>
                                <div className='w-[13%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            type="text"
                                            autoComplete='off'
                                            id={`cost_per_item${index}`}
                                            maxLength={13}
                                            className={`${submitSelected && (field.cost_per_item === "" || field.cost_per_item === undefined || (qty2Error && parseFloat(Number(field.cost_per_item)).toFixed(2) === "0.00") || (costError && Number(field.cost_per_item) > Number(field.cost_price))) ? "redBorder" : ""} text-end w-full inpt-fld error_border`}
                                            placeholder={`0.00`}
                                            value={field.cost_per_item}
                                            onChange={(e) => { handleFieldChange(index, 'cost_per_item', e.target.value)}}
                                            disabled={field.item_name === ''}
                                            isAmountField = {true}
                                            onFocus={clearIfValueIsZero(index,'cost_per_item')}
                                            onBlur={setZeroIfEmpty(index,'cost_per_item')}
                                        />  
                                    </div>   
                                </div>
                                <div className='w-[13%] px-2'>
                                    <div className='w-full'>
                                        <input
                                            type="text"
                                            disabled
                                            autoComplete='off'
                                            id={`total_cost${index}`}
                                            maxLength={30}
                                            className={` ${submitSelected && (field.total_cost === "") ? "redBorder" : ""} inpt-fld w-full text-end error_border`}
                                            placeholder={`0.00`}
                                            value={field?.total_cost === '' ? '' : parseFloat(field?.total_cost).toFixed(2)}
                                        />   
                                    </div>   
                                </div>
                            
                                <div class={`${newStateFields?.length === 1 ? "w-[7%]" : "w-[7%]"} flex items-center`}>
                                    {index === newStateFields?.length - 1 ? (
                                        <>
                                            {index !== 0 && <div className='group relative z-[10]'>
                                                <img
                                                    src="/images/delete-bg-red-icon.svg"
                                                    alt="icon"
                                                    className="ml-1 mr-1 cursor-pointer delete-icon"
                                                    onClick={() => handleRemoveClassField(index)}
                                                />
                                                <span class="absolute top-7 left-[-3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>

                                            </div>}
                                            {index !== 19 && <div className='group relative z-[10]'>
                                                <img
                                                    src="/images/add-icon-blue.svg"
                                                    id="plus_iconn"
                                                    alt="icon"
                                                    className="ml-1 cursor-pointer add-icon"
                                                    onClick={() => handleAddClassField()} />
                                                <span class="absolute top-7 left-[7px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Add</span>
                                            </div>}
                                        </>
                                    ) : (
                                        <div className='group relative z-[10]'>
                                            <img
                                                src="/images/delete-bg-red-icon.svg"
                                                alt="icon"
                                                className="ml-1 cursor-pointer delete-icon"
                                                onClick={() => handleRemoveClassField(index)}
                                            />
                                            <span class="absolute top-7 left-[-3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>

                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>))}
                    <div className='flex items-center my-2' style={{ 'width': '93%' }}>
                        <p className='text-lg font-semibold text-black w-[100%] justify-end inline-flex mr-[5px]'>
                            <span className='w-[21%] justify-end inline-flex mr-[10px]'>GRN Total</span>
                            <span className='min-w-[11%] justify-end inline-flex'>{newStateFields.reduce((acc, item) => acc + (parseFloat(item.total_cost) || 0), 0).toFixed(2)}</span>
                        </p>
                    </div>  
                </div>
            </div>}

            {openConfirmation && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleSubmit}
                        handleClose={() => setOpenConfirmation(false)}
                        crossMark
                        additionalMessage={`A PO is being created for '${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})', which appears to be a back-dated entry.`}
                        message = {`Do you want to continue?`}
                        buttonName = {`Continue`}
                        tittle={'Back Dated Entry'}
                        dialogueWidth={'500px'}
                        textPosition={'text-start'}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
            {!isUnique && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleSubmit}
                        handleClose={() => setIsUnique(true)}
                        crossMark
                        message = {`The vendor Invoice # already exists, Do you want to continue?`}
                        buttonName = {`Continue`}
                        tittle={'Vendor Invoice # Exists'}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
            {isPoClear && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleClear}
                        handleClose={() => setIsPoClear(false)}
                        crossMark
                        message = {`Entered GRN details for the PO will be cleared. Would you like to proceed?`}
                        buttonName = {`OK`}
                        tittle={'GRN Details'}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
        </CardHeader>
    )
}
